import { Box } from "@chakra-ui/react";
import { customEvent, EventProps } from "../utils/customEvent";
import { colors, ColorIcon } from "goi_common";

export const CloseButton = ({
  onClose,
  closeEvent,
  top = "20px",
  right = "20px",
}: {
  onClose: () => void;
  closeEvent?: EventProps;
  top?: string;
  right?: string;
}) => {
  const handleClose = () => {
    if (closeEvent) customEvent(closeEvent);
    onClose();
  };

  return (
    <Box
      onClick={handleClose}
      cursor="pointer"
      css={{
        zIndex: 999,
        position: "absolute",
        top,
        right,
      }}
    >
      <ColorIcon name="icon-x-mono" color={colors.gray900} size={24} />
    </Box>
  );
};
